// extracted by mini-css-extract-plugin
module.exports = {"alignLeft":"PanelContentHeader_alignLeft___5yr8","alignCenter":"PanelContentHeader_alignCenter__4HA4t","tableCell":"PanelContentHeader_tableCell__7euc_"};